export enum BuilderDropdownOptionsEnum {
  SELECT_PROJECT = "Select Project",
  SELECT_BUILDER = "Select Builder",
}
